// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "root-13QrI";
var _5 = "label-1KKDt";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "root", _5 as "label" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "root": _4, "label": _5 }
